<template>
    <modal
        class="af-form"
        title="Add New Folder"
        header-bg-variant="blue-600"
        header-text-variant="white"
    >
        <loading-component
            v-if="isLoading"
            type="spinner"
            class="af-form__loading"
        />

        <div class="af-form__content flex-form">
            <section class="flex-form__section">
                <div class="flex-form__field">
                    <div class="flex-form__label">Folder Name</div>

                    <input
                        class="flex-form__input"
                        type="text"
                        :value="folderName"
                        @input="onInput"
                    >
                </div>
            </section>
        </div>

        <template v-slot:modal-footer>
            <button class="flex-modal__button flex-modal__button--cancel" @click="hideModal">
                Cancel
            </button>

            <button class="flex-modal__button flex-modal__button--continue" :disabled="!folderName" @click="onAdd">
                Add
            </button>
        </template>
    </modal>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';

import LoadingComponent from '@/components/shared/loading/loading-component';
import * as service from '@/sitecore/sitecore-data-service';
import { LOAD_COMPONENT_TREE } from '@/store/types/action-types';
import { HIDE_MODAL, SHOW_ALERT, SHOW_SNACKBAR } from '@/store/types/mutation-types';
import appThemes from '@/data/app-themes';

export default {
    name: 'modal-add-folder',
    components: { LoadingComponent },

    props: {
        modalData: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            folderName: '',
            isLoading: false,
        };
    },

    computed: {
        ...mapState({
            appTheme: state => state.page.appTheme,
        }),

        loadingIconColor() {
            return appThemes[this.appTheme].app.color;
        },
    },

    methods: {
        ...mapActions({
            loadComponentTree: LOAD_COMPONENT_TREE,
        }),

        ...mapMutations({
            hideModal: HIDE_MODAL,
            showAlert: SHOW_ALERT,
            showSnackbar: SHOW_SNACKBAR,
        }),

        onInput(e) {
            this.folderName = e.target.value;
        },

        async onAdd() {
            this.isLoading = true;

            const response = await service.createComponentCategory(this.modalData.id, this.folderName);

            if (response.status === 'error') {
                this.showAlert({ description: `An error was encountered while attempting to add the folder: ${ response.error }` });
                this.isLoading = false;
                return;
            }

            // reload tree to get new data
            await this.loadComponentTree();

            this.hideModal();

            this.showSnackbar({
                title: 'Success!',
                text: 'The folder has been successfully added.',
            });
        },
    },
};
</script>

<style lang="scss">
.af-form {
    &__content {
        min-width: 500px;
    }
}
</style>
